export * from './outgoing.transfer.detail.i';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/entity/transfer/detail/index.ts